import { Group, Button, Text, Badge, ActionIcon } from '@mantine/core';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';

interface YearSelectorProps {
  selectedYear: number;
  availableYears: number[];
  yearsWithData: number[];
  onChange: (year: number) => void;
  disabled?: boolean;
}

export function YearSelector({
  selectedYear,
  availableYears,
  yearsWithData,
  onChange,
  disabled,
}: YearSelectorProps) {
  const currentIndex = availableYears.indexOf(selectedYear);
  const canGoPrev = currentIndex > 0;
  const canGoNext = currentIndex < availableYears.length - 1;

  const handlePrev = () => {
    if (canGoPrev) {
      onChange(availableYears[currentIndex - 1]);
    }
  };

  const handleNext = () => {
    if (canGoNext) {
      onChange(availableYears[currentIndex + 1]);
    }
  };

  return (
    <Group gap="xs" justify="center">
      <ActionIcon
        variant="subtle"
        size="lg"
        onClick={handlePrev}
        disabled={!canGoPrev || disabled}
        aria-label="Poprzedni rok"
      >
        <IconChevronLeft size={20} />
      </ActionIcon>

      <Group gap="xs">
        {availableYears.map((year) => {
          const hasData = yearsWithData.includes(year);
          const isSelected = year === selectedYear;

          return (
            <Button
              key={year}
              variant={isSelected ? 'filled' : 'light'}
              color={isSelected ? 'blue' : 'gray'}
              size="md"
              onClick={() => onChange(year)}
              disabled={disabled}
              style={{
                position: 'relative',
                minWidth: '80px',
              }}
            >
              <Group gap={4}>
                <Text size="sm" fw={isSelected ? 600 : 500}>
                  {year}
                </Text>
                {hasData && !isSelected && (
                  <Badge
                    size="xs"
                    color="green"
                    variant="filled"
                    circle
                    aria-label="Dane dostępne"
                    style={{
                      width: '8px',
                      height: '8px',
                      padding: 0,
                      minWidth: 0,
                      minHeight: 0,
                    }}
                  >
                    {' '}
                  </Badge>
                )}
              </Group>
            </Button>
          );
        })}
      </Group>

      <ActionIcon
        variant="subtle"
        size="lg"
        onClick={handleNext}
        disabled={!canGoNext || disabled}
        aria-label="Następny rok"
      >
        <IconChevronRight size={20} />
      </ActionIcon>
    </Group>
  );
}
